

























































































































































































import type { BDropdown } from 'bootstrap-vue';
import { Component, Watch } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase, Overlay } from '../components';
import type { BudgetVariants, Comp, FzpReport } from '../types';
import * as fzp from './fzp';
import FzpReportPart from './FzpReportPart.vue';
import type { Fzp } from './types';


// region Типы
/**
 * Информация об отчете и его содержимое
 */
interface ReportInfoAndContent {
    /*
    Структура из kz.csi.stat.csc.modules.budget.staffing_table.StaffingTableController.getFzpInfoAndContent:
    {
        "report": <StafftabFzpReportDto>,
        "budgetVariant": <null | BudgetVariantsDto>,
        "content": <StafftabFzp.Report>
    }
     */

    /**
     * Информация об отчете
     */
    report: FzpReport;

    /**
     * Информация о варианте бюджета
     */
    budgetVariant: BudgetVariants | null;

    /**
     * Содержимое отчета
     */
    content: Fzp.Report;
}

/**
 * Части листа отчета.
 *
 * Возможные значения:
 *
 * * 'FZP_TOTAL' - "Всего";
 * * 'FZP_CALC' - "Расчетные"
 * * 'FZP_NA' - "Вновь вводимые в сеть"
 */
type ReportSheetPart = 'FZP_TOTAL' | 'FZP_CALC' | 'FZP_NA';

/**
 * Данные для компонента отображения листа
 */
interface SheetComponentData {
    /**
     * Выбранный лист
     */
    sheet: Fzp.ReportSheet;

    /**
     * Содержимое листа
     */
    data: Fzp.ReactiveReportPart;

    /**
     * Выбранная часть листа отчета
     */
    part: ReportSheetPart;

    /**
     * Контроллер листа (определение редактируемых колонок, пересчет значений в строке)
     */
    controller: Fzp.Controller;
}
// endregion


const translates = {
    actions: {
        get back(): string {
            return i18n.choose(
                'Назад',
                'Артқа',
                'Back',
            );
        },
        get resetAndReload(): string {
            return i18n.choose(
                'Сбросить и загрузить заново',
                'Бастапқы қалпына келтіріп, қайта жүктеп алыңыз',
                'Reset and load again',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    errors: {
        get cannotDisplayContent(): string {
            return i18n.choose(
                'Ошибка страницы - по неизвестной причине не получается отобразить содержимое отчета',
                'Бет қатесі - есеп мазмұны белгісіз себептермен көрсетілмеді',
                'Page error - report content could not be displayed for some unknown reason',
            );
        },
        cannotLoadReportInfoAndContent(id: number): string {
            return i18n.choose(
                () => `Не удалось загрузить содержимое и информацию об отчете #${id}`,
                () => `#${id} есебінің мазмұны мен ақпараты жүктелмеді`,
                () => `Cannot load content and information of report #${id}`,
            )();
        },
        cannotSaveReportContent(id: number): string {
            return i18n.choose(
                () => `Не удалось сохранить содержимое отчета #${id}`,
                () => `#${id} есебінің мазмұнын сақтау сәтсіз аяқталды`,
                () => `Cannot save content of report #${id}`,
            )();
        },
    },
    messages: {
        get emptyReport(): string {
            return i18n.choose(
                'Не найдены данные для отчета ФЗП. Необходимо отправить отчеты по формам в свод.',
                'ЕАҚ есебі үшін деректер табылмады. Нысандар бойынша есептерді жиынтыққа жіберу қажет.',
                'No data found for the FZP report. Form-based reports must be submitted for consolidation.',
            );
        },
        reportContentSaved(id: number): string {
            return i18n.choose(
                () => `Данные сохранены`,
                () => `Деректер сақталды`,
                () => `Data saved`,
            )();
        },
    },
    reportInfoPanel: {
        get title(): string {
            return i18n.choose(
                'Информация об отчете',
                'Есеп туралы ақпарат',
                'Report information',
            );
        },
        fields: {
            budgetVariant: {
                get title(): string {
                    return i18n.choose(
                        'Вариант бюджета',
                        'Бюджеттік нұсқа',
                        'Budget variant',
                    );
                },
            },
            id: {
                get title(): string {
                    return 'ID';
                },
            },
            newArrivals: {
                get title(): string {
                    return i18n.choose(
                        'Новоприбывшие',
                        'Жаңа келгендер',
                        'New arrivals',
                    );
                },
            },
            region: {
                get title(): string {
                    return i18n.choose(
                        'Регион (область, город, район)',
                        'Аймақ (облыс, қала, аудан)',
                        'Region (oblast, city, district)',
                    );
                },
            },
            reportDate: {
                get title(): string {
                    return i18n.choose(
                        'Дата отчета',
                        'Есеп беру күні',
                        'Report date',
                    );
                },
            },
            reportYear: {
                get title(): string {
                    return i18n.choose(
                        'Год отчета',
                        'Есеп беру жылы',
                        'Report year',
                    );
                },
            },
            republicBudget: {
                get title(): string {
                    return i18n.choose(
                        'РБ',
                        'РБ',
                        'RB',
                    );
                },
            },
            sheet: {
                get title(): string {
                    return i18n.choose(
                        'Лист отчета',
                        'Есеп парағы',
                        'Report sheet',
                    );
                },
            },
        },
    },
    reportSheetParts: {
        get FZP_CALC(): string {
            return i18n.choose(
                'Основные',
                'Негізгі',
                'Main',
            );
        },
        get FZP_NA(): string {
            return i18n.choose(
                'Вновь вводимые в сеть',
                'Жаңадан енгізілетін',
                'Newly introduced',
            );
        },
        get FZP_TOTAL(): string {
            return i18n.choose(
                'Всего',
                'Барлығы',
                'Total',
            );
        },
    },
    reportSheetTypes: {
        /*
        https://plane.smartderek.kz/main/browse/EAK-990/#comment-abc1fb58-733e-4980-a3c9-f60e1b140d75
        из названий "Государственные служащие (МБ)", "Гражданские служащие (МБ)" и "Правоохранительные органы (МБ)" убрать суффиксы "(МБ)";
         */
        get CIVIL_MB(): string {
            /*
            return i18n.choose(
                'Гражданские служащие (МБ)',
                'Азаматтық қызметкерлер (ЖБ)',
                'Civil servants (MB)',
            );
             */
            return i18n.choose(
                'Гражданские служащие',
                'Азаматтық қызметкерлер',
                'Civil servants',
            );
        },
        get CIVIL_RB(): string {
            return i18n.choose(
                'Гражданские служащие (РБ)',
                'Азаматтық қызметкерлер (РБ)',
                'Civil servants (RB)',
            );
        },
        get GOV_MB(): string {
            /*
            return i18n.choose(
                'Государственные служащие (МБ)',
                'Мемлекеттік қызметшілер (ЖБ)',
                'Government servants (MB)',
            );
             */
            return i18n.choose(
                'Государственные служащие',
                'Мемлекеттік қызметшілер',
                'Government servants',
            );
        },
        get GOV_RB(): string {
            return i18n.choose(
                'Государственные служащие (РБ)',
                'Мемлекеттік қызметшілер (РБ)',
                'Government servants (RB)',
            );
        },
        get MVD_MB(): string {
            /*
            return i18n.choose(
                'Правоохранительные органы (МБ)',
                'Құқық қорғау органдары (ЖБ)',
                'Law enforcement agencies (MB)',
            );
             */
            return i18n.choose(
                'Правоохранительные органы',
                'Құқық қорғау органдары',
                'Law enforcement agencies',
            );
        },
        get MVD_RB(): string {
            return i18n.choose(
                'Правоохранительные органы (РБ)',
                'Құқық қорғау органдары (РБ)',
                'Law enforcement agencies (RB)',
            );
        },
    },
};


@Component({
    components: {
        FzpReportPart,
        Overlay,
    },
})
export default class FzpReportPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Параметры компонента
    /**
     * ID отчета (параметр страницы)
     */
    get id(): number | null {
        const idString = this.$route.params.id;
        const id = parseInt(idString);

        if (!(Number.isSafeInteger(id) && (String(id) === idString.trim()))) {
            return null;
        }

        return id;
    }

    @Watch('id', { immediate: false })
    public onIdChanged(id: number | null) {
        if (id === null) {
            this.reportInfoAndContent = null;
        } else {
            this.loadReportInfoAndContent();
        }
        fzp.localState.resetExpandedRows();
        fzp.localState.reportId = id;
    }
    // endregion


    // region Lifecycle
    protected mounted() {
        super.mounted();
        this.onIdChanged(this.id);
    }
    // endregion


    // region Утилиты
    public translates = translates;

    public get loading(): boolean {
        return this.loadingReportInfoAndContent;
    }
    // endregion


    // region Информация + содержимое отчета
    public loadingReportInfoAndContent = false;

    public reportInfoAndContent: ReportInfoAndContent | null = null;

    public get report(): FzpReport | null {
        return this.reportInfoAndContent?.report ?? null;
    }

    public get reportRegionText(): string | null {
        const report = this.report;
        if (report === null) {
            return null;
        }

        const regionCode = report.regionCode
        const regionTitle = i18n.choose(
            report.regionNameRu ?? '',
            report.regionNameKk ?? report.regionNameRu ?? '',
            report.regionNameRu ?? '',
        );

        return `${regionCode} - ${regionTitle}`;
    }

    public get reportDateText(): string | null {
        const report = this.report;
        if (report === null) {
            return null;
        }

        const date = report.reportDate;
        if (date === null) {
            return null;
        }

        return this.$d(date);
    }

    public get budgetVariant(): BudgetVariants | null {
        return this.reportInfoAndContent?.budgetVariant ?? null;
    }

    public get budgetVariantText(): string | null {
        const budgetVariant = this.budgetVariant;
        if (budgetVariant === null) {
            return null;
        }

        const title = i18n.choose(
            budgetVariant.nameRu,
            budgetVariant.nameKk ?? budgetVariant.nameRu,
            budgetVariant.nameEn ?? budgetVariant.nameRu,
        );

        return title;
    }

    public get newArrivals(): boolean | null {
        return this.report?.newArrivals ?? null;
    }

    public get republicBudget(): boolean | null {
        return this.report?.republicBudget ?? null;
    }

    private loadReportInfoAndContent() {
        if (this.loadingReportInfoAndContent) {
            console.error("Cannot load report info and content - another loading is running");
            return;
        }

        const id = this.id;
        if (id === null) {
            console.error("Cannot load report info and content - ID is null");
            return;
        }

        this.loadingReportInfoAndContent = true;
        this.reportInfoAndContent = null;
        this.request<ReportInfoAndContent>(
            {
                url: `/api/budget/staffing_table/fzp/info-and-content/${id}`,
            },
            (data) => {
                const untypedData = (data as unknown);

                let corrupted = false;
                if (typeof untypedData === 'object') {
                    corrupted = (untypedData === null);
                } else {
                    corrupted = true;
                }

                if (corrupted) {
                    this.toast('success', '', this.translates.errors.cannotDisplayContent);
                    this.reportInfoAndContent = null;
                } else {
                    if (
                        (data.content.govMbPart === null)
                        &&
                        (data.content.govRbPart === null)
                        &&
                        (data.content.civilMbPart === null)
                        &&
                        (data.content.civilRbPart === null)
                        &&
                        (data.content.mvdMbPart === null)
                        &&
                        (data.content.mvdRbPart === null)
                    ) {
                        this.toast('success', '', this.translates.messages.emptyReport);
                    }

                    this.reportInfoAndContent = data;
                }
            },
            () => translates.errors.cannotLoadReportInfoAndContent(id),
            () => {
                this.loadingReportInfoAndContent = false;
            },
        );
    }

    private saveReportContent() {
        if (this.loadingReportInfoAndContent) {
            console.error("Cannot save report content - another loading is running");
            return;
        }

        const content = this.content;
        if (content === null) {
            console.error("Cannot save report content - content is null");
            return;
        }

        const id = this.id;
        if (id === null) {
            console.error("Cannot save report content - ID is null");
            return;
        }

        this.loadingReportInfoAndContent = true;

        this.request(
            {
                url: `/api/budget/staffing_table/fzp/report-content/${id}`,
                method: 'POST',
                data: content.createPlainCopy(),
            },
            () => {
                this.toast('success', '', translates.messages.reportContentSaved(id));
                content.markAsUnchanged();
            },
            () => (translates.errors.cannotSaveReportContent(id)),
            () => {
                this.loadingReportInfoAndContent = false;
            },
        );
    }
    // endregion


    // region Листы (части) отчета, вкладки
    /**
     * Содержимое отчета
     */
    public content: Fzp.ReactiveReport | null = null;

    public get isContentWithoutSheets(): boolean {
        const content = this.content;
        if (content === null) {
            return false;
        }

        if (content.govMbPart !== null) {
            return false;
        }
        if (content.govRbPart !== null) {
            return false;
        }
        if (content.civilMbPart !== null) {
            return false;
        }
        if (content.civilRbPart !== null) {
            return false;
        }
        if (content.mvdMbPart !== null) {
            return false;
        }
        if (content.mvdRbPart !== null) {
            return false;
        }

        return true;
    }

    @Watch('reportInfoAndContent')
    public onReportInfoAndContentChanged(reportInfoAndContent: ReportInfoAndContent | null) {
        fzp.localState.reportHasContent = (
            ((reportInfoAndContent?.content?.govMbPart ?? null) !== null)
            ||
            ((reportInfoAndContent?.content?.govRbPart ?? null) !== null)
            ||
            ((reportInfoAndContent?.content?.civilMbPart ?? null) !== null)
            ||
            ((reportInfoAndContent?.content?.civilRbPart ?? null) !== null)
            ||
            ((reportInfoAndContent?.content?.mvdMbPart ?? null) !== null)
            ||
            ((reportInfoAndContent?.content?.mvdRbPart ?? null) !== null)
        );

        const plainContent = (reportInfoAndContent?.content ?? null);
        if (plainContent === null) {
            this.content = null;
        } else {
            this.content = fzp.createReactiveReport(plainContent);
        }
    }

    /**
     * Выбранный лист отчета
     */
    public selectedSheetContent: Fzp.ReactiveReportPart | null = null;

    /**
     * Выбранный ключ листа отчета
     */
    public selectedSheet: Fzp.ReportSheet | null = null;

    /**
     * Выбранная часть листа отчета
     */
    public selectedSheetPart: ReportSheetPart = 'FZP_TOTAL';

    /**
     * Опции выпадающего списка листов отчета
     */
    public get reportSheetOptions(): Array<Comp.DropdownItemDef<Fzp.ReportSheet>> {
        const content = this.content;
        if (content === null) {
            return [];
        }

        const result: Array<Comp.DropdownItemDef<Fzp.ReportSheet>> = [];

        if (content.govMbPart !== null) {
            result.push({
                value: 'GOV_MB',
                text: translates.reportSheetTypes.GOV_MB,
            });
        }
        if (content.govRbPart !== null) {
            result.push({
                value: 'GOV_RB',
                text: translates.reportSheetTypes.GOV_RB,
            });
        }
        if (content.civilMbPart !== null) {
            result.push({
                value: 'CIVIL_MB',
                text: translates.reportSheetTypes.CIVIL_MB,
            });
        }
        if (content.civilRbPart !== null) {
            result.push({
                value: 'CIVIL_RB',
                text: translates.reportSheetTypes.CIVIL_RB,
            });
        }
        if (content.mvdMbPart !== null) {
            result.push({
                value: 'MVD_MB',
                text: translates.reportSheetTypes.MVD_MB,
            });
        }
        if (content.mvdRbPart !== null) {
            result.push({
                value: 'MVD_RB',
                text: translates.reportSheetTypes.MVD_RB,
            });
        }

        return result;
    }

    /**
     * Опции вкладок частей листа отчета
     */
    public get reportSheetParts(): Array<{ value: ReportSheetPart; text: string }> {
        /**
         * Признак "отображать вновь вводимые в сеть"
         */
        let addFzpNa: boolean = true;

        /*
        https://plane.smartderek.kz/main/browse/EAK-64/
        25. На примере отчета №56 - если Новоприбывшие не были выбраны при формировании отчета, то вкладка "Вновь вводимые в сеть" не должна отображаться вообще
         */
        if (this.report?.newArrivals !== true) {
            addFzpNa = false;
        }

        /*
        https://plane.smartderek.kz/main/browse/EAK-64/
        23. Вкладки "Вновь вводимые в сеть" у Госслужащих не должно быть
         */
        if ((this.selectedSheet === 'GOV_MB') || (this.selectedSheet === 'GOV_RB')) {
            addFzpNa = false;
        }

        /*
        https://plane.smartderek.kz/main/browse/EAK-989/#comment-5750af7c-c9f5-4044-bcf0-46f369954c88

        Вкладки "Вновь вводимые в сеть" у Правоохранительных органов не должно быть
         */
        if ((this.selectedSheet === 'MVD_RB') || (this.selectedSheet === 'MVD_MB')) {
            addFzpNa = false;
        }

        const result: Array<{ value: ReportSheetPart; text: string }> = [
            { value: 'FZP_TOTAL', text: translates.reportSheetParts.FZP_TOTAL },
            { value: 'FZP_CALC', text: translates.reportSheetParts.FZP_CALC },
        ];

        if (addFzpNa) {
            result.push({ value: 'FZP_NA', text: translates.reportSheetParts.FZP_NA });
        }

        return result;
    }

    /**
     * Маппинг ключа листа отчета на соответствующую часть содержимого
     */
    private get sheetPartByKey(): Record<Fzp.ReportSheet, Fzp.ReactiveReportPart | null> | null {
        const content = this.content;
        if (content === null) {
            return null;
        }

        return {
            GOV_MB: content.govMbPart,
            GOV_RB: content.govRbPart,
            CIVIL_MB: content.civilMbPart,
            CIVIL_RB: content.civilRbPart,
            MVD_MB: content.mvdMbPart,
            MVD_RB: content.mvdRbPart,
        };
    }

    /**
     * Данные для компонента отображения листа
     */
    private get sheetComponentData(): SheetComponentData | null {
        const selectedSheetContent = this.selectedSheetContent;
        if (selectedSheetContent === null) {
            return null;
        }

        const selectedSheet = this.selectedSheet;
        if (selectedSheet === null) {
            return null;
        }

        const selectedSheetPart = this.selectedSheetPart;

        const controller = fzp.createController(selectedSheet, selectedSheetContent);

        return {
            sheet: selectedSheet,
            data: selectedSheetContent,
            part: selectedSheetPart,
            controller: controller,
        };
    }

    @Watch('selectedSheet')
    public onSelectedSheetChanged(sheet: Fzp.ReportSheet | null) {
        const map = this.sheetPartByKey;
        if (sheet === null || map === null) {
            this.selectedSheetContent = null;
        } else {
            this.selectedSheetContent = map[sheet];
        }

        (this.$refs as unknown as Record<string, BDropdown | undefined>).drop?.hide(true);
        this.selectedSheetPart = 'FZP_TOTAL';
    }

    @Watch('content')
    public onContentChanged(content: Fzp.ReactiveReport | null) {
        if (content === null) {
            this.selectedSheet = null;
            this.selectedSheetContent = null;
        } else {
            const availableSheets: Array<Fzp.ReportSheet | null> = [];
            if (content.govMbPart !== null) {
                availableSheets.push('GOV_MB');
            }
            if (content.govRbPart !== null) {
                availableSheets.push('GOV_RB');
            }
            if (content.civilMbPart !== null) {
                availableSheets.push('CIVIL_MB');
            }
            if (content.civilRbPart !== null) {
                availableSheets.push('CIVIL_RB');
            }
            if (content.mvdMbPart !== null) {
                availableSheets.push('MVD_MB');
            }
            if (content.mvdRbPart !== null) {
                availableSheets.push('MVD_RB');
            }

            const currentIndex = availableSheets.indexOf(this.selectedSheet);
            if (currentIndex < 0) {
                this.selectedSheet = availableSheets[0] ?? null;
            }
        }
    }
    // endregion


    // region Действия
    public onBackClicked() {
        this.$router.back();
    }

    public onSaveClicked() {
        this.saveReportContent();
    }

    public onResetClicked() {
        this.loadReportInfoAndContent();
    }
    // endregion
}
